// extracted by mini-css-extract-plugin
module.exports = {"card":"SuggestedPosts_card__0hAlr","wrapper":"SuggestedPosts_wrapper__0fOjI"};